import { FC } from 'react';
import { Feature } from '@shinetools/pricing-plan-library';

import SunshineTag, { SunshineTagProps } from 'components/_core/SunshineTag';

import { useUpgradablePlanBadgeComponentQuery } from './hooks/useUpgradablePlanBadgeComponentQuery';

interface UpgradablePlanBadgeProps
  extends Omit<SunshineTagProps, 'colorScheme' | 'icon'> {
  feature: Feature;
}

const UpgradablePlanBadge: FC<UpgradablePlanBadgeProps> = ({
  feature,
  ...badgeProps
}) => {
  const { planName } = useUpgradablePlanBadgeComponentQuery(feature);

  if (!planName) {
    return null;
  }

  return (
    <SunshineTag colorScheme="grey" icon="star" {...badgeProps}>
      Shine {planName}
    </SunshineTag>
  );
};

export default UpgradablePlanBadge;
